import React from 'react';

import { useTagsState } from './TagsContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';

const TagsTable = () => {
  const tagsState = useTagsState();

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Value</Th>
          <Th>Normalized Value</Th>
        </Tr>
      </Thead>
      <Tbody>
        {tagsState?.tags?.map(tag => (
          <Tr key={tag.id}>
            <Td><a href={`/tags/${tag.id}`}>{tag.value}</a></Td>
            <Td>{tag.normalizedValue}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default TagsTable;
